import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useRef, useState } from "react";
import styles from "./index.module.scss";
import ToastV2 from "@/components/common/BaseToast";
import { useTranslations } from "next-intl";
export const GLOBAL_COUNTDOWN = 60;
export const SendCode = props => {
  const t = useTranslations();
  const {
    verifyFunc
  } = props;
  const [restTime, setRestTime] = useState(0);
  const timerRef = useRef(null);
  const resendVerify = () => {
    if (timerRef.current) return;
    const rse = verifyFunc();
    if (!rse) return;
    setRestTime(GLOBAL_COUNTDOWN);
    setTimeout(() => {
      setIntervalTimeHandle();
    }, 0);
    rse.then(res => {
      if (res.code === 0) {
        return;
      } else {
        timerRef.current && clearInterval(timerRef.current);
        timerRef.current = null;
        setRestTime(0);
        ToastV2.info(res.msg);
      }
    });
  };
  const setIntervalTimeHandle = () => {
    timerRef.current = setInterval(() => {
      setRestTime(prev => {
        if (prev <= 0 && timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return prev;
        } else {
          return prev - 1;
        }
      });
    }, 1000);
  };
  return /*#__PURE__*/_jsx("span", {
    className: classNames({
      [styles.resend_btn]: true,
      [styles.rest_num]: restTime > 0
    }),
    onClick: resendVerify,
    children: restTime == 0 ? t("Login_SendCode_Action") : "".concat(restTime, "s")
  });
};